'use client';

import { useEffect, useState } from 'react';

import { Container } from '../../components/Container/Container';
import { MetaTags } from '../../components/MetaTags/MetaTags';
import { PostsViewerDesktop } from '../../components/PostsViewer/components/PostsViewerDesktop/PostsViewerDesktop';
import { useDistanceFromTop } from '../../helpers/hooks/useDistanceFromTop';
import { useScreenHeight } from '../../helpers/hooks/useScreenHeight';
import { getPostUrl } from '../../helpers/urls';
import { GetPost_entry } from '../../interfaces/graphql';
import { OtherCatchesFromThisUser } from './components/OtherCatchesFromThisUser';
import { SinglePostListItem } from '../../components/PostsViewer/components/SinglePostListItem/SinglePostListItem';
import { AppDownloadModal } from '../../components/AppDownloadModal/AppDownloadModal';
import { useIsMobileDevice } from '../../helpers/hooks/useIsMobileDevice';
import { getNodesFromConnection } from '../../helpers/graphql';

interface IProps {
  post: GetPost_entry;
  appShare: boolean;
}
export const PostView = ({ post, appShare }: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { user, text, video } = post;
  const [modalSeen, setModalSeen] = useState(false);
  const distanceFromTop = useDistanceFromTop();
  const screenHeight = useScreenHeight();
  const images = getNodesFromConnection(post.images);
  const isMobileDevice = useIsMobileDevice();
  const previewImgUrl = images[0]?.url ?? video?.screenshot.url;
  // eslint-disable-next-line no-magic-numbers
  const screenHeightToShowModal = (screenHeight / 100) * 25;

  useEffect(() => {
    if (appShare && !modalSeen && distanceFromTop > screenHeightToShowModal) {
      setIsAppDownloadModalOpen(true);
      setModalSeen(true);
    }
  }, [distanceFromTop, screenHeight, appShare, modalSeen, screenHeightToShowModal]);

  return (
    <>
      <MetaTags
        title={`Check out this post from ${user.nickname}`}
        link={getPostUrl(post._id)}
        description={text.text ?? undefined}
        image={previewImgUrl}
      />
      <div className={!isMobileDevice ? 'bg-lake-fog' : ''}>
        {isMobileDevice ? (
          <SinglePostListItem
            onNotLoggedIn={() => {
              setIsAppDownloadModalOpen(true);
            }}
            post={post}
          />
        ) : (
          <Container className="py-sm">
            <div className="w-col-10 mx-auto h-[700px]">
              <PostsViewerDesktop posts={[post]} currentPostId={post._id} />
            </div>
          </Container>
        )}
        <Container>
          <OtherCatchesFromThisUser
            userId={user._id}
            userNickname={user.nickname}
            excludeId={post._id} // we know that post._id does not have a catch but the component expects it
            customHeading={`Discover catches from ${user.nickname}`}
          />
        </Container>
      </div>

      <AppDownloadModal
        appDownloadSource="PostView"
        appDownloadSourceId={post._id}
        modalHeader={`See all posts from ${user.nickname} in the Fishbrain app`}
        modalText="Download the app to see more info about your favorite anglers, ability to follow them and see what they catch next"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
        showTextOnMobile
      />
    </>
  );
};
